var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"create-task-btn",on:{"click":_setup.onCreateTask}},[_vm._v("发布任务")])
}
var staticRenderFns = []

export { render, staticRenderFns }